var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"float-right mt-4",attrs:{"x-small":"","fab":"","color":"pink","dark":""},on:{"click":function($event){return _vm.openAddNoteDialog()}}},[_c('v-icon',[_vm._v("mdi-plus")])],1),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.notes),function(note,i){return _c('v-flex',{key:i + Math.random(),attrs:{"sm4":"","xs12":""}},[_c('StickyNotes',{attrs:{"note":note},on:{"note-deleted":_vm.refreshNotes}})],1)}),1),_c('GlobalDialogSlot',{attrs:{"dialog":_vm.dialog,"title":'Add Note to ' + _vm.getCompanyLabels.matter},on:{"close-dialog":_vm.closeDialog}},[_c('v-select',{staticClass:"mx-6",attrs:{"items":_vm.billables,"label":"Billable Activity"},model:{value:(_vm.selectedBillable),callback:function ($$v) {_vm.selectedBillable=$$v},expression:"selectedBillable"}}),_c('DatePickerWithMenu',{attrs:{"label":"Select Billing Date"},on:{"date-selected":_vm.setBillingDate}}),(
        (_vm.selectedBillable &&
          _vm.selectedBillable.itemType == 'billable' &&
          _vm.selectedBillable.qtyIncrementID != 1) ||
        (_vm.selectedBillable && _vm.selectedBillable.itemType == 'service') ||
        (_vm.selectedBillable && _vm.selectedBillable.itemType == 'product') ||
        (_vm.selectedBillable && _vm.selectedBillable.itemType != 'transport')
      )?_c('v-text-field',{staticClass:"mx-6",attrs:{"label":_vm.selectedBillable.qtyIncrementID &&
        (_vm.selectedBillable.qtyIncrementID == 2 ||
          _vm.selectedBillable.qtyIncrementID == 7)
          ? 'Minutes'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 3
          ? 'Copies'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 4
          ? 'Folios'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 5
          ? 'Number of Calls'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 6
          ? 'Number of Attendances'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 8
          ? 'Number of Persons'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 9
          ? 'Hours'
          : _vm.selectedBillable.qtyIncrementID &&
            _vm.selectedBillable.qtyIncrementID == 10
          ? 'Number of Pages'
          : _vm.selectedBillable.itemType &&
            _vm.selectedBillable.itemType == 'service'
          ? 'Hours'
          : _vm.selectedBillable.itemType &&
            _vm.selectedBillable.itemType == 'product'
          ? 'Quantity'
          : _vm.selectedBillable.itemType &&
            _vm.selectedBillable.itemType == 'transport'
          ? 'Kilometers'
          : 'Flat Fee [Nothing is required here]'},model:{value:(_vm.units),callback:function ($$v) {_vm.units=$$v},expression:"units"}}):_vm._e(),_c('v-textarea',{staticClass:"px-6 py-4",attrs:{"clear-icon":"","name":"input-7-1","label":"Description","hint":"Type Your Note Here"},model:{value:(_vm.newNoteContent),callback:function ($$v) {_vm.newNoteContent=$$v},expression:"newNoteContent"}}),_c('v-btn',{staticClass:"mb-3 ml-4",attrs:{"color":"primary","dark":"","rounded":""},on:{"click":function($event){return _vm.saveNewNote()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-content-save")]),_vm._v(" Save Note")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }